import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import {
  getAllReviewsInstructorAction,
  getInstructorReviewSummaryAction,
  getMoreReviewsInstructorAction,
} from "@redux/modules/review/slices";
import {
  NoData,
  ReviewComment,
  ReviewCommentPlaceHolder,
  ReviewSummary,
  SpinnerCustom,
} from "@components";
import styles from "./styles/InstructorReviewPage.module.css";

const placeholder = Array.from(Array(3).keys());

const InstructorReviewPage = () => {
  // state
  const [ratingSelected, setRatingSelected] = useState(0);
  const { getAllReviewsInstructor, getInstructorReviewSummary } = useSelector(
    (state) => state.review
  );
  const { reviews, processing, pagination, processingGetMore } =
    getAllReviewsInstructor;
  const {
    ratingList,
    avgRating,
    totalReviews,
    processing: processingSummary,
  } = getInstructorReviewSummary;

  const dispatch = useDispatch();

  // variables

  // logics before hooks

  // hooks

  // logics
  const handleSeeMore = () => {
    dispatch(getMoreReviewsInstructorAction({ rating: ratingSelected }));
  };

  // effects
  useEffect(() => {
    dispatch(getAllReviewsInstructorAction({}));
    dispatch(getInstructorReviewSummaryAction());
  }, []);

  useEffect(() => {
    dispatch(getAllReviewsInstructorAction({ rating: ratingSelected }));
  }, [ratingSelected]);

  // render
  return (
    <Container className="pt-4">
      <h5>
        <i className="bi bi-card-text mr-2"></i>
        My feedback
      </h5>
      <Row className="mt-4">
        <Col xs={12} lg={5} className="mb-5">
          <ReviewSummary
            title="All Student Feedback"
            subTitle="All Rating"
            numRating={avgRating}
            ratingList={ratingList}
            totalReviews={totalReviews}
            processing={processingSummary}
            ratingSelected={ratingSelected}
            onChange={(rating) => setRatingSelected(rating)}
          />
        </Col>
        <Col>
          <div className="d-flex flex-wrap justify-content-between">
            <h5>All Reviews</h5>
          </div>

          <div
            className={clsx("d-flex flex-column mt-4", styles.commentContainer)}
          >
            {processing &&
              placeholder.map((val) => <ReviewCommentPlaceHolder key={val} />)}

            {reviews &&
              reviews?.length !== 0 &&
              reviews.map((review, index) => {
                return <ReviewComment key={index} {...review} />;
              })}

            {!processing && (!reviews || reviews?.length === 0) && (
              <NoData title="No Review Found!" className="p-0 border-0" />
            )}

            {!processing && pagination.HasNext && reviews?.length !== 0 && (
              <button
                className={styles.btnSeeMore}
                onClick={handleSeeMore}
                disabled={processingGetMore}
              >
                {processingGetMore ? <SpinnerCustom /> : "See More Reviews"}
              </button>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
InstructorReviewPage.displayName = "InstructorReviewPage";

/* required: props types */
InstructorReviewPage.propTypes = {};

/* required: default props */
InstructorReviewPage.defaultProps = {};

export { InstructorReviewPage };
